import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSEO } from '../../hooks/useSEO';
import { ReactComponent as Logo } from '../../assets/images/logo.svg';
import styles from './NotFound.module.css';

const NotFound: React.FC = () => {
  const { t } = useTranslation();

  const seo = useSEO({
    titleKey: 'seo.notFound.title',
    descriptionKey: 'seo.notFound.description',
    routeKey: 'home',
    noIndex: true,
  });

  return (
    <div className={styles.notFound}>
      {seo}
      <Logo className={styles.logo} />
      <h1 className={styles.title}>404</h1>
      <p className={styles.text}>{t('notFound.title')}</p>
      <p className={styles.subtitle}>{t('notFound.text')}</p>
      <Link to="/" className={styles.homeLink}>
        {t('notFound.backHome')}
      </Link>
    </div>
  );
};

export default NotFound;
